import React from "react";
import { Box, Grid, RootRef } from "@material-ui/core";
import Chip from "@mui/material/Chip";
import { customSorting } from "src/common/utils/app.util";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import { deepCompireObjects } from "src/common/utils/helpers";
import { Loader } from "src/components/atoms/Loader";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonCheckBox from "src/components/CommonCheckBox/CommonCheckBox";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";

type Props = {
  closed: () => void;
  //findsUniqueVal: (val: string) => boolean;
  onApplySelRecordFilter: (data: any, clearAll: boolean, restoreOrg: boolean) => void;
  selRec: any[];
  heading?: string;
  rows?: any;
  columns?: any;
};
export default function CommonUniqueValuesFilter({
  //findsUniqueVal,
  closed,
  heading,
  columns,
  rows,
  selRec,
  onApplySelRecordFilter,
}: Props) {
  const [selectedFilter, setSelectedFilter] = React.useState<any>(selRec);
  const [currentSelFilter, setCurrentSelFilter] = React.useState<string>("");
  const [internalLoader, setInternalLoader] = React.useState<boolean>(false);
  const [selectedUniqueRec, setSelectedUniqueRec] = React.useState<any[]>([]);
  const [selectedRec, setSelectedRec] = React.useState<string[]>([]);
  const [elementsRendor, setElemetsRendor] = React.useState<number>(50);
  const domRef: any = React.useRef();
  React.useEffect(() => {
    setInternalLoader(true);
    setTimeout(() => {
      if (currentSelFilter) {
        if (dataAllready()) {
          setSelectedFilter(selRec);
        } else {
          const uniqueObjArray: any[] = [
            ...new Map(rows.map((item: any) => [item[currentSelFilter], item])).values(),
          ];
          const newRecord = selectedFilter?.map((item: any) => {
            if (Object.keys(item)[0] === currentSelFilter) {
              setSelectedUniqueRec(customSorting(uniqueObjArray, currentSelFilter, "asc", true));
              return {
                [currentSelFilter]: uniqueObjArray,
              };
            } else {
              return item;
            }
          });
          setSelectedFilter(newRecord);
        }
      }
      setInternalLoader(false);
    }, 1);
  }, [currentSelFilter]);
  const filterAddRemove = (value: string) => {
    return selectedFilter?.filter((item: any) => Object.keys(item)[0] !== value);
  };
  const dataAllready = () => {
    let exist = false;
    for (let i = 0; i < selRec.length; i++) {
      if (Object.keys(selRec[i])[0] === currentSelFilter) {
        setSelectedUniqueRec(
          customSorting(selRec[i][currentSelFilter], currentSelFilter, "asc", true)
        );
        exist = true;
        break;
      }
    }
    return exist;
  };
  const updateCheckValue = (ischeck: boolean, rec: any) => {
    setInternalLoader(true);
    const selData = selectedFilter?.map((cuItem: any) => {
      if (Object.keys(cuItem)[0] === currentSelFilter) {
        const ab = cuItem[currentSelFilter].map((item: any) => ({
          ...item,
          checked: item.id === rec.id ? ischeck : item.checked || false,
        }));
        setSelectedUniqueRec(customSorting(ab, currentSelFilter, "asc", true));
        return { [currentSelFilter]: ab };
      } else {
        return cuItem;
      }
    });
    setSelectedFilter(selData);
    setInternalLoader(false);
  };
  const checkFilterLable = (lab: string) => {
    let res = "";
    const result = columns?.find((oType: any) => oType.field === lab);
    if (result) res = result.headerName;
    return res;
  };
  const onScroll = () => {
    if (domRef && domRef?.current) {
      if (
        domRef?.current?.scrollTop + domRef?.current?.clientHeight + 200 >=
        domRef?.current?.scrollHeight
      ) {
        setElemetsRendor(elementsRendor + 25);
      }
    }
  };
  const fieldsSecection = () => {
    const result: any[] = [];
    if (columns?.length) {
      columns.map((col: any) => {
        if (
          col.field != "__row_group_by_columns_group__" &&
          col.field != "__check__" &&
          col.field != "actions" &&
          col.field != "" &&
          col.field != "icons"
        ) {
          result.push(col);
        }
      });
    }
    return customSorting(result, "field", "asc", true);
  };
  const { height } = UseWindowDimensions();
  let wHeight = 0;
  let gridMaxHeight = 0;
  wHeight = height - 132;
  gridMaxHeight = height - 268;
  return (
    <>
      <Loader open={internalLoader} />
      <Box style={{ height: wHeight }}>
        <CommonDrawer
          heading={heading || "Filter Unique Values"}
          isOpen={true}
          drawerWidth={420}
          closeDrawer={() => {
            closed && closed();
          }}
        >
          <Box mb={2} />
          <Grid spacing={2} container direction="row">
            <Grid item xs={12} md={12}>
              {selRec &&
                selRec.length > 0 &&
                selRec?.map((cuItem: any, i: number) => {
                  return (
                    <>
                      <Chip
                        size="small"
                        key={`chip${i}`}
                        label={checkFilterLable(Object.keys(cuItem)[0])}
                        onDelete={() => {
                          const da = Object.keys(cuItem)[0];
                          if (da === currentSelFilter) {
                            setCurrentSelFilter("");
                            setSelectedRec([]);
                          }
                          const drec = filterAddRemove(da);
                          setSelectedFilter(drec);
                          onApplySelRecordFilter(drec, false, true);
                          setElemetsRendor(50);
                        }}
                        onClick={() => {
                          setInternalLoader(true);
                          setElemetsRendor(50);
                          setSelectedRec([]);
                          const da = Object.keys(cuItem)[0];
                          setCurrentSelFilter(da);
                          const filterExit = selectedFilter?.filter(
                            (item: any) => Object.keys(item)[0] === da
                          );
                          if (filterExit?.length === 0) {
                            const curr: string = da;
                            setSelectedFilter([...selectedFilter, { [curr]: [] }]);
                          }
                          setInternalLoader(false);
                        }}
                      />
                    </>
                  );
                })}
            </Grid>
            <Grid item xs={12} md={12}>
              <Grid spacing={0} container direction="row">
                <Grid item xs={12} md={9}>
                  <CommonAutoCompleteField
                    label="Fields"
                    name="fields"
                    optionsType={fieldsSecection()}
                    value={columns?.find((oType: any) => oType.field === currentSelFilter) || null}
                    getOptionLabel={(option: any) => option?.headerName}
                    onChange={(v) => {
                      setCurrentSelFilter(v?.field || "");
                      if (v?.field) {
                        setElemetsRendor(50);
                        const filterExit = selectedFilter?.filter(
                          (item: any) => Object.keys(item)[0] === v?.field
                        );
                        if (filterExit?.length === 0) {
                          const curr: string = v.field;
                          setSelectedFilter([...selectedFilter, { [curr]: [] }]);
                        }
                      }
                      setSelectedRec([]);
                    }}
                    compaireValue="field"
                    disableClearable
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <CommonButton
                    onClick={() => {
                      setCurrentSelFilter("");
                      setSelectedUniqueRec([]);
                      setSelectedRec([]);
                      onApplySelRecordFilter([], true, false);
                    }}
                  >
                    Clear All Filters
                  </CommonButton>
                </Grid>
              </Grid>
            </Grid>
            <RootRef rootRef={domRef}>
              <Grid
                item
                xs={12}
                md={12}
                style={{ height: gridMaxHeight, overflowX: "auto" }}
                onScroll={onScroll}
              >
                {!internalLoader &&
                  rows &&
                  currentSelFilter &&
                  selectedFilter &&
                  selectedFilter?.length > 0 &&
                  selectedUniqueRec?.length > 0 && (
                    <Box>
                      {selectedUniqueRec?.slice(0, elementsRendor).map((ro) => (
                        <Box ml={1} key={`${ro.id}-box`}>
                          <CommonCheckBox
                            key={`${ro.id}-CommonCheckBox`}
                            label={
                              ro[currentSelFilter] || ro[currentSelFilter] == false
                                ? ro[currentSelFilter].toString()
                                : ""
                            }
                            value={ro.checked}
                            handleChange={(e: any) => {
                              setInternalLoader(true);
                              if (e.target.checked) {
                                updateCheckValue(true, ro);
                                const dta = [...selectedRec];
                                dta.push(ro[currentSelFilter]);
                                setSelectedRec(dta);
                              } else {
                                updateCheckValue(false, ro);
                                const dta = selectedRec?.filter(
                                  (item) => item !== ro[currentSelFilter]
                                );
                                setSelectedRec(dta);
                              }
                              setInternalLoader(false);
                            }}
                          />
                        </Box>
                      ))}
                    </Box>
                  )}
              </Grid>
            </RootRef>
            <Grid item xs={12} md={12}>
              <Box textAlign="right" mt={1} mb={1}>
                <CommonButton
                  onClick={() => {
                    closed && closed();
                  }}
                >
                  Cancel
                </CommonButton>
                <CommonButton
                  disable={
                    !(
                      currentSelFilter &&
                      selectedUniqueRec?.some((el) => el.checked) &&
                      !deepCompireObjects(selectedFilter, selRec)
                    )
                  }
                  onClick={() => {
                    onApplySelRecordFilter(selectedFilter, false, false);
                  }}
                  isGreen
                >
                  Apply
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
        </CommonDrawer>
      </Box>
    </>
  );
}
